import { SiteType, siteTypes } from "@ots-frontend/ots-data";
import { BaseDbCodeSelect, DbCodeSelectProps } from "../base-db-code-select";

type Props = DbCodeSelectProps<SiteType>;

export const SiteTypeSelect = (props: Props) => {
  const { options = Object.values(siteTypes), ...rest } = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
